import { lazy, Suspense, useState } from "react";
import { Switch, Route } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import routes from "./config";
import { Styles } from "../styles/styles";

const Router = () => {
  const [is3D, setIs3D] = useState(false);

  return (
    <Suspense fallback={null}>
      <Styles />
      <Header is3D={is3D} setIs3D={setIs3D} />
      <Switch>
        {routes.map((routeItem) => {
          const Component = lazy(
            () => import(`../pages/${routeItem.component}`)
          );

          return (
            <Route
              key={routeItem.component}
              path={routeItem.path}
              exact={routeItem.exact}
              render={(props) => <Component {...props} is3D={is3D} />}
            />
          );
        })}
      </Switch>
      <Footer />
    </Suspense>
  );
};

export default Router;
